<template>
  <div>
    <b-toast class="pwa-promotion" variant="warning" :title="$t('install')" v-model="showPwaPromotion" static no-auto-hide @hidden="hidePromotion"> {{ $t('pwaPromotion') }} <br /> <br /> <b-button @click="install" size="sm" variant="success"> {{ $t('install') }} </b-button></b-toast>
    <router-view :key="$store.getters.containerKey"></router-view>
  </div>
  
</template>

<script>

export default {
  name: 'app', 
  data: function() {
    return {
      installPrompt: null,
      showPwaPromotion: false
    }
  },

  computed: {
    locale() {
        if (this.$route.query.lang) {
          return this.$route.query.lang
        }

        return this.$store.getters.getLocale
    },
  },

  methods: {
    install() {
      if (this.installPrompt) this.installPrompt.prompt();
    },

    hidePromotion() {
      localStorage.setItem('pwa_promotion', new Date())
    }
  },  

  created() {
    console.log("App created")
    
    document.body.classList.add('sidebar-minimized');

    window.addEventListener('beforeinstallprompt', (e) => {
    // Prevents the default mini-infobar or install dialog from appearing on mobile
    e.preventDefault();
    // Save the event because you'll need to trigger it later.
    this.installPrompt = e;
    // Show your customized install prompt for your PWA
    // Your own UI doesn't have to be a single element, you
    // can have buttons in different locations, or wait to prompt
    // as part of a critical journey.
    let promotion = localStorage.getItem('pwa_promotion')

    if (!promotion) {
      this.showPwaPromotion = true
    } else {
       let today = new Date()
       let hidden = new Date(promotion)

       const diffTime = Math.abs(today - hidden);
       const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

       if (diffDays > 7 && this.$route.path.startsWith("/admin")) {
        this.showPwaPromotion = true
       }
    }
  });
  }
}

</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
   @import 'assets/scss/style';

   .pwa-promotion {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 9999;
   }
</style>
